import { useParams } from 'react-router-dom';
import { useDealStatusHistoryQuery } from '../../shared/hooks';
import React from 'react';
import { CerebroDrawer, CerebroHeading, CerebroText } from '../../shared/components';
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Skeleton } from '@mui/material';
import { DateUtils, EnumUtils } from '../../shared/utils';
import { DealStatusStat } from '../../shared/models';
import { ESignDocument, ESignDocumentStateMap } from '../../shared/models/ESignDocument';
import { DocumentStatusDot } from '../../shared/components/DocumentStatusDot';

interface ContractDocumentsSendHistoryDrawePropsProps {
    docs?: ESignDocument[];
    open?: boolean;
    onClose: () => void;
}

export const ContractDocumentsSendHistoryDraweProps: React.FC<ContractDocumentsSendHistoryDrawePropsProps> = ({ docs, open, onClose }) => {
    const { guid } = useParams<'guid'>();
    var query = useDealStatusHistoryQuery(guid);
    const ref = React.useRef<HTMLDivElement>(null);

    return (
        <CerebroDrawer ref={ref} open={open} onClose={onClose}>
            <CerebroHeading>Agreement Status History</CerebroHeading>

            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Status</TableCell>
                            <TableCell>Customer</TableCell>
                            <TableCell>Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {docs?.map(doc => {
                            return (<>
                                <TableRow key={doc.eSignDocumentGuid}>
                                    <TableCell>
                                        <>
                                            <CerebroText>
                                                <>
                                                    <DocumentStatusDot state={doc?.state} sx={{ marginRight: 1 }} />
                                                    {doc ? ESignDocumentStateMap[doc.state] : ''}
                                                </>
                                            </CerebroText>
                                        </>
                                    </TableCell>
                                    <TableCell>
                                        <CerebroText>{doc?.eSignDocumentActivityLogs?.find(t => t != null)?.customerEmail}</CerebroText>
                                    </TableCell>
                                    <TableCell>{doc.modifiedOnLocalTime}</TableCell>
                                </TableRow>
                            </>)
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </CerebroDrawer>
    );
};